import React from 'react';

const About = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-16 space-y-20">
      <section className="text-center">
        <h1 className="text-4xl font-bold text-teal-600 mb-6">
          Your Long-Term Operational Partner
        </h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          We believe in deep integration and permanent partnerships, not just temporary solutions.
          Our mission is to help businesses scale efficiently while maintaining quality.
        </p>
      </section>

      <section className="grid md:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-3xl font-bold mb-6">Our Approach</h2>
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold mb-2">Deep Integration</h3>
              <p className="text-gray-600">
                We don't just provide staff – we become part of your team, understanding your
                culture, processes, and goals. Our team members work as if they're your own
                employees, ensuring seamless collaboration.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">Long-Term Commitment</h3>
              <p className="text-gray-600">
                Unlike traditional BOT models, we're here to stay and grow with you. We believe
                in building lasting relationships that create sustained value for your business.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">Quality First</h3>
              <p className="text-gray-600">
                We maintain high standards while optimizing costs. Our unique model allows us to
                provide premium quality service at competitive rates, helping you maximize ROI.
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-8 rounded-lg">
          <h3 className="text-xl font-semibold mb-4">The InfAI Difference</h3>
          <ul className="space-y-4 text-gray-600">
            <li>• Full operational integration, not just consulting</li>
            <li>• Long-term partnership model</li>
            <li>• Deep understanding of your business</li>
            <li>• Cost-effective without compromising quality</li>
            <li>• Flexible scaling based on your needs</li>
            <li>• Continuous improvement focus</li>
          </ul>
        </div>
      </section>

      <section className="bg-teal-50 p-8 rounded-lg">
        <h2 className="text-3xl font-bold mb-6 text-center">Our Values</h2>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <h3 className="text-xl font-semibold mb-4">Excellence</h3>
            <p className="text-gray-600">
              We strive for the highest quality in everything we do, ensuring your business
              receives premium service.
            </p>
          </div>
          <div className="text-center">
            <h3 className="text-xl font-semibold mb-4">Partnership</h3>
            <p className="text-gray-600">
              We succeed when you succeed. Your goals become our goals, and we work tirelessly
              to achieve them together.
            </p>
          </div>
          <div className="text-center">
            <h3 className="text-xl font-semibold mb-4">Innovation</h3>
            <p className="text-gray-600">
              We continuously explore new ways to improve efficiency and deliver better results
              for your business.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
